module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      color: true, active: _vm.color === _vm.active_color
    },
    style: ({
      background: _vm.color
    }),
    on: {
      "click": _vm.select
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68ae157c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Color.vue
// module id = 71
// module chunks = 0